import { type ChangeEvent } from 'react';

import { type Transform } from '@shared/ui-components/field-controller/field-controller';

export const allowOnlyNumbersTransform: Transform<HTMLInputElement> = {
  input: (value: string) => String(value).replaceAll(/\D/gu, ''),
  output: (event: ChangeEvent<HTMLInputElement>) => event.target.value.replaceAll(/\D/gu, ''),
};

export const formatNumberWithCommasTransform: Transform<HTMLInputElement> = {
  input: (value: string) => {
    if (!value) return '';
    const numericValue = String(value).replaceAll(',', '');

    if (numericValue === '' || Number.isNaN(Number(numericValue))) return '';

    return Number(numericValue).toLocaleString('en-US');
  },
  output: (event: ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value.replaceAll(/\D/gu, '');

    if (rawValue === '') return '';

    return Number(rawValue).toLocaleString('en-US');
  },
};
